import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

if (environment.sentryIO) {
  Sentry.init({
    dsn: 'https://4ee7d0a9da51473e8d27caf36b669d95@o776643.ingest.sentry.io/5798889',
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['https://admin.mbase.app', 'https://mbase.devarea.app'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    environment: environment.envName,
    tracesSampleRate: 1.0,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
